@if (labsLoading()) {
  <div class="loading-spinner--container ">
    <app-loading-spinner></app-loading-spinner>
  </div>
} @else if (laboratory) {
  <div>
    <div id="title--container">
      <h4>Add a new user</h4>
      <h5>{{ laboratory.laboratoryName }}</h5>
    </div>
    <hr />
    <div id="account--container">
      <div class="card">
        <div class="header">
          <div class="card-title">Personal Details</div>
          <div class="body1">Enter the new user's information</div>
        </div>
        <hr class="card-divider" aria-hidden="true" />
        <div class="content">
          <div class="form--container">
            <form [formGroup]="addUserForm">
              <app-underlined-form-field
                [parentForm]="addUserForm"
                [field]="firstNameField"
              ></app-underlined-form-field>
              <app-underlined-form-field
                [parentForm]="addUserForm"
                [field]="lastNameField"
              ></app-underlined-form-field>
              <app-underlined-form-field
                [parentForm]="addUserForm"
                [field]="emailField"
              ></app-underlined-form-field>
              <app-underlined-dropdown-form-field
                [field]="userRoleField"
                [parentForm]="addUserForm"
              ></app-underlined-dropdown-form-field>
            </form>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="header">
          <div class="card-title">Laboratory Memberships</div>
          <div class="body1">Assign this user to one or more laboratories</div>
        </div>
        <hr class="card-divider" aria-hidden="true" />
        <div class="content">
          @if (availableLabsField.options.length > 0) {
            <div class="form--container">
              <form [formGroup]="addUserForm">
                <app-underlined-dropdown-form-field
                  [field]="availableLabsField"
                  [parentForm]="addUserForm"
                ></app-underlined-dropdown-form-field>
              </form>
            </div>
          } @else if (availableLabs().length > 0) {
            <div class="no-items-message">All available laboratories have been assigned.</div>
          }
          @if (selectedLabs().length < 1 && !labSelectError()) {
            <span id="no-users">No laboratories selected yet.</span>
          }
          @if (labSelectError()) {
            <span class="error"> {{ labSelectError() }} </span>
          }
          @if (selectedLabs().length > 0) {
            @for (lab of selectedLabs(); track lab) {
              <app-lab-card
                [lab]="lab"
                [role]="addUserForm.get(userRoleField.key)?.value"
                (removeClicked)="removeLab($event)"
              ></app-lab-card>
            }
          }
        </div>
      </div>
      <div id="button--container">
        <app-button
          label="Add User"
          buttonId="add-btn"
          (buttonClicked)="onSubmit()"
          [isDisabled]="addUserForm.invalid"
          [isProcessing]="isProcessing()"
        >
        </app-button>
      </div>
    </div>
  </div>
} @else {
  <app-error-page
    title="You are not a member of this lab"
    primaryText="Sorry, you cannot access this page unless you are a member of a lab"
  ></app-error-page>
}
<app-modal
  id="create-account"
  titleText="Success"
  [primaryText]="addUserSuccessMessage()"
  primaryButtonText="close"
  primaryButtonId="add-user-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error()?.message"
  primaryButtonText="close"
  primaryButtonId="error-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
